module.exports = __webpack_public_path__ + "img/cultureOpen4.9bacfef4.png";